export default __webpack_public_path__ + "static/media/world_map_finger.a54fbf1b.png";